export const REPORT_TYPES = {
  SALES: 'sales',
  SALES_BY_DAY: 'salesByDay',
  RETURNS: 'returns',
  SALES_BY_PRODUCT: 'salesByProduct',
  BEST_SELLERS: 'bestSellers',
  SALES_BY_WAREHOUSE: 'product-daily-sales-by-warehouse',
  CANCELLATIONS: 'cancellations',
  RLRS: 'rlrs',
};

export const REPORT_TYPES_ENDPOINTS_BY_KPIS = {
  [REPORT_TYPES.SALES]: 'analytics/sales',
  [REPORT_TYPES.SALES_BY_DAY]: 'analytics/sales',
  [REPORT_TYPES.RETURNS]: 'reports/cancellations',
  [REPORT_TYPES.SALES_BY_PRODUCT]: 'analytics/product-daily-sales-by-model',
  [REPORT_TYPES.BEST_SELLERS]: 'analytics/product-top-sellers',
  [REPORT_TYPES.SALES_BY_WAREHOUSE]: 'analytics/product-daily-sales-by-warehouse',
  [REPORT_TYPES.CANCELLATIONS]: 'reports/cancellations',
  [REPORT_TYPES.RLRS]: 'reports/cancellations',
};

export const REPORT_TYPES_EXPORT_FILE_NAME = {
  [REPORT_TYPES.SALES]: 'sales-by-channel',
  [REPORT_TYPES.SALES_BY_PRODUCT]: 'sales-by-product',
  [REPORT_TYPES.SALES_BY_WAREHOUSE]: 'sales-by-warehouse',
  [REPORT_TYPES.RETURNS]: 'returns',
  [REPORT_TYPES.CANCELLATIONS]: 'cancellations',
  [REPORT_TYPES.RLRS]: 'rlrs',
};

export const REPORT_FILTERS = {
  DATE_TYPE: 'dateType',
  SALES_CHANNELS: 'salesChannels',
  COUNTRIES: 'countries',
  DATE_RANGE: 'dateRange',
  CURRENCIES: 'currencies',
  WAREHOUSES: 'warehouses',
  BY_DATE_TYPE: 'byDateType',
};

export const DATE_TYPE_TOTAL = 'total';
export const DATE_TYPE_WEEKS = 'weeks';
export const DATE_TYPE_DAYS = 'days';

export const DATE_TYPES_LABELS = {
  [DATE_TYPE_TOTAL]: 'Total',
  [DATE_TYPE_WEEKS]: 'Weeks',
  [DATE_TYPE_DAYS]: 'Days',
};

export const dateTypes = {
  total: DATE_TYPES_LABELS[DATE_TYPE_TOTAL],
  days: DATE_TYPES_LABELS[DATE_TYPE_DAYS],
  weeks: DATE_TYPES_LABELS[DATE_TYPE_WEEKS],
};

export const BY_DATE_TYPE_RETURN_CREATED = 'returned_at';
export const BY_DATE_TYPE_ORDER_CREATED = 'order_created_at';
export const BY_DATE_TYPE_CANCELLATION_CREATED = 'cancelled_at';
export const BY_DATE_TYPE_RLR_CREATED = 'rlr_created_at';

export const byDateTypes = {
  [BY_DATE_TYPE_RETURN_CREATED]: 'Returned Date',
  [BY_DATE_TYPE_ORDER_CREATED]: 'Created Date',
  [BY_DATE_TYPE_CANCELLATION_CREATED]: 'Cancellation Date',
  [BY_DATE_TYPE_RLR_CREATED]: 'RA Date',
};

export const biEventNameMapping = {
  [REPORT_TYPES.SALES_BY_WAREHOUSE]: 'sales-by-warehouse',
  [REPORT_TYPES.SALES_BY_PRODUCT]: 'sales-by-product',
  [REPORT_TYPES.SALES]: 'sales-by-channel',
  [REPORT_TYPES.RETURNS]: 'returns',
  [REPORT_TYPES.RLRS]: 'rlrs',
};

export const ANALYTICS_START_DATE = new Date(2024, 0, 1);
